import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import useLang from "../../hooks/use-lang";
import { useMemo } from "react";
import { formatExternalUrl, stripHtml } from "../../helpers/utils";

export default function VerticalTimeline() {
    const { our_story } = useSelector((state) => state.app);
    const LangUtils = useLang();

    const formattedData = useMemo(() => {
        return our_story.map((data) => ({
            id: data.id,
            title: LangUtils.getLangValue(data, "title"),
            subtitle: LangUtils.getLangValue(data, "subtitle"),
            description: LangUtils.getLangValue(data, "description"),
            button_text: LangUtils.getLangValue(data, "button_text"),
            external_url: data.external_url,
            image_url: data.section_image_1,
        }));
    }, [our_story, LangUtils]);

    return (
        <div className="container">
            <Timeline
                position="alternate"
                sx={{
                    "& .MuiTypography-root": {
                        // Targets all Typography elements within Timeline
                        fontFamily: "Matter, sans-serif", // Replace 'YourFontFamily' with your desired font
                    },
                }}
            >
                {formattedData.map((data, index) => (
                    <TimelineItem key={index.toString()}>
                        <TimelineSeparator>
                            <TimelineDot />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                            <Typography variant="h6" component="h1">
                                {data.title}
                            </Typography>
                            <Typography>
                                {stripHtml(data.description)}
                            </Typography>
                            {data.image_url && (
                                <Box
                                    component="img"
                                    sx={{
                                        width: { xs: 1, md: 0.6 }, // 100% of the container width
                                        aspectRatio: 1,
                                        objectFit: "cover",
                                        marginTop: 2, // theme spacing
                                        borderRadius: "50%",
                                    }}
                                    src={formatExternalUrl(data.image_url)}
                                    alt={data.title}
                                />
                            )}
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </div>
    );
}
